import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function gridLifeAtCumnor() {
    if (document.querySelector('.page-template-home')) {
        const gridWrapper = document.querySelector(
            '[data-target="life-grid-wrapper"]'
        )

        if (gridWrapper) {
            if (window.innerWidth > 1024) {
                function createGrid() {
                    const title = document.querySelector(
                        '[data-target="life-grid-title"]'
                    )
                    const text = document.querySelector(
                        '[data-target="life-grid-description"]'
                    )
                    const grid = gridWrapper.querySelector(
                        '[data-target="life-grid"]'
                    )
                    const mainImg = document.querySelector(
                        '[data-target="main-img"]'
                    )
                    const button = mainImg.querySelector(
                        '[data-target="button-overlay"]'
                    )
                    const overlay = mainImg.querySelector(
                        '[data-target="main-img-overlay"]'
                    )

                    gsap.set(grid, { scale: 4 })
                    gsap.set(button, { autoAlpha: 0 })
                    gsap.set(title, { x: window.innerWidth })
                    gsap.set(text, {
                        autoAlpha: 0,
                        translateY: 50,
                    })
                    gsap.set(overlay, { autoAlpha: 0.75 })

                    const tl = gsap.timeline()

                    ScrollTrigger.create({
                        trigger: gridWrapper,
                        animation: tl,
                        start: 'top top',
                        end: '600% bottom',
                        pin: true,
                        scrub: 1,
                        immediateRender: false,
                        anticipatePin: 1,
                        // markers: document.body.classList.contains('logged-in')
                        //     ? true
                        //     : false,
                    })

                    tl.to(title, {
                        x: `${-window.innerWidth * 1.8}px`,
                        autoAlpha: 1,
                        duration: 0.35,
                    })
                        .to(
                            text,
                            {
                                translateY: 0,
                                autoAlpha: 1,
                                duration: 0.05,
                            },
                            '>-0.3'
                        )
                        .to(
                            text,
                            {
                                translateY: '-50%',
                                autoAlpha: 0,
                                duration: 0.05,
                            },
                            '>0.05'
                        )
                        .to(
                            overlay,
                            {
                                autoAlpha: 0,
                                duration: 0.1,
                            },
                            '<0.025'
                        )
                        .to(
                            grid,
                            {
                                scale: 1,
                                duration: 0.15,
                            },
                            '<'
                        )
                        .to(
                            button,
                            {
                                autoAlpha: 1,
                                duration: 0.05,
                            },
                            '>-0.05'
                        )
                }

                createGrid()

                window.addEventListener('resize', () => {
                    createGrid()
                })
            }
        }
    }

    ScrollTrigger.refresh()
}

export default gridLifeAtCumnor
